module.exports = __webpack_public_path__ + "media/images/demo/profile-picture-anonymous-3c3ce3f89bb64e810ca13708310f5d79.svg";